<template>
  <table class="table table-responsive">
    <thead>
      <tr>
        <th scope="col">No. Invoice</th>
        <th scope="col">Kuantiti</th>
        <th scope="col">Nilai Retur (Rp)</th>
        <th scope="col">Diskon</th>
        <th scope="col">Total Pengembalian</th>
        <th scope="col">Detail</th>
        <th scope="col"></th>
        <th scope="col"></th>
      </tr>
    </thead>
    <tbody>
      <tr
        v-for="item in items"
        :key="item.uuid"
      >
        <td>{{ item.invoice_number }}</td>
        <td>{{ item.qty }}</td>
        <td>{{ formatToRupiah(item.total) }}</td>
        <td>{{ formatToRupiah(item.discount) }}</td>
        <td>{{ formatToRupiah(item.total - item.discount) }}</td>
        <td colspan="3" v-if="item.is_split_payment_method">
          <div v-for="detail, index in item.payment_method_details" :key="index">
            <b-row>
              <b-col cols="6">
                <span>{{ paymentMethod(detail.payment_method) }}</span>
              </b-col>
              <b-col cols="6">
                <span>: {{ formatToRupiah(detail.amount) }}</span>
              </b-col>
            </b-row>
          </div>
        </td>
        <td colspan="3" v-if="!item.is_split_payment_method">-</td>
      </tr>
    </tbody>
    <tbody v-if="items.length === 0">
      <tr>
        <td
          colspan="4"
          class="text-center"
        >
          Data kosong.
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script>
import { BRow, BCol } from 'bootstrap-vue';

export default {
  name: 'ReturSelling',
  components: {
    BRow,
    BCol
  },
  props: ['items'],
  methods: {
    paymentMethod(method) {
      const paymentMethod = {
        cash: 'Tunai',
        transfer: 'Transfer',
        wallet: 'Deposit',
        piutang: 'Piutang', 
      }
      return paymentMethod[method] || method || '-';
    },
    formatToRupiah(amount) {
      const formatter = new Intl.NumberFormat('id-ID', {
        style: 'currency',
        currency: 'IDR',
        minimumFractionDigits: 0,
      });
      return formatter.format(amount);
    },
  },
};
</script>
